import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";
import { sendOtpAction } from "../../redux/actions/noticeToVacate";
import { useTranslation } from "react-i18next";

const SendOtp = ({ handleOtpSent, showSendOtpModal, setShowSendOtpModal }) => {
  const dispatch = useDispatch();
  const [form, setForm] = useState({
    email: "",
    phone: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const validateForm = () => {
    let tempErrors = {};

    if (!form.email) {
      tempErrors.email = "Email is required";
    } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(form.email)) {
      tempErrors.email = "Invalid email format";
    }

    if (!form.phone) {
      tempErrors.phone = "Phone number is required";
    } else if (form.phone.replace(/\D/g, "").length !== 10) {
      tempErrors.phone = "Phone number must be 10 digits";
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSendOTP = async () => {
    try {
      if (!validateForm()) return;
      setLoading(true);
      const result = await dispatch(
        sendOtpAction({
          email: form.email,
          Phone_Mobile: form.phone,
        })
      );
      console.log(result, "result");
      if (handleOtpSent) {
        handleOtpSent(result);
        setForm({email: "",
          phone: "",})
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={showSendOtpModal} centered>
      <ModalHeader>
      {t('tenantApp.keyReturn.sendOtpHeading')}
      </ModalHeader>
      <ModalBody className="bg-white">
        <div className="form-group">
          <label className="form-label">{t('tenantApp.keyReturn.email')}</label>
          <input
            type="email"
            className={`form-control ${errors.email ? "is-invalid" : ""}`}
            placeholder={t('tenantApp.keyReturn.EnterEmailPlaceholder')}
            value={form.email}
            onChange={(e) => {
              setForm({ ...form, email: e.target.value });
              setErrors((prevErrors) => ({ ...prevErrors, email: "" }));
            }}
          />
          {errors.email && (
            <div className="invalid-feedback">{errors.email}</div>
          )}
        </div>
        <div className="form-group">
          <label className="form-label">{t('tenantApp.keyReturn.Phone')}</label>
          <input
            type="text"
            className={`form-control ${errors.phone ? "is-invalid" : ""}`}
            placeholder={t('tenantApp.keyReturn.EnterPhonePlaceholder')}
            value={form.phone}
            onChange={(e) => {
              let x = e.target.value
                .replace(/\D/g, "")
                .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
              e.target.value = !x[2]
                ? x[1]
                : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
              setForm({ ...form, phone: e.target.value });
              setErrors((prevErrors) => ({ ...prevErrors, phone: "" }));
            }}
          />
          {errors.phone && (
            <div className="invalid-feedback">{errors.phone}</div>
          )}
        </div>
        <div className="float-right">
        <button
          className="btn btn-primary mr-3"
          onClick={handleSendOTP}
          disabled={loading}
        >
          {loading ? (
            <Spinner color="white" size="sm">
              Loading...
            </Spinner>
          ) : (
            t('tenantApp.keyReturn.sendOTP')
          )}
        </button>
        <button
          className="btn btn-secondary "
          onClick={() => {
            setForm({
              email: "",
              phone: "",
            })
            setErrors({})
            setShowSendOtpModal(false)
          }}
          disabled={loading}
        >
          {t('tenantApp.keyReturn.close')}
        </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default SendOtp;
